import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

export class SendEmail {
  public static send(invoiceId: string, email: string): RequestConfigType {
    return RequestConfig.post(`/account/invoices/${invoiceId}/send-email`, { email });
  }
}
